import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
  email: Yup.string().required('Email is required.'), // Removed email validation
  password: Yup.string()
    .required('Password is required.')
    .matches(/\b([A-Z])/g, 'Password requires first letter Capital')
    .max(18, 'Password is too long - should be maximum 20 chars.')
    .min(7, 'Password is too short - should be 8 chars minimum.')
    .matches(/[0-9]/, 'Password requires a number')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[^\w]/, 'Password requires a special chars')
});
export const emailSchema = Yup.object().shape({
  email: Yup.string().required('Email is required.'), // Removed email validation
 
});
export const otpSchema = Yup.object().shape({
  otp: Yup.string()
    .required('OTP is required.')
    .matches(/^\d{6}$/, 'OTP must be exactly 6 digits')
    .length(6, 'OTP must be exactly 6 digits'),
});

export const otpLoginSchema = Yup.object().shape({
  email: Yup.string().required('Email is required.'),
  password: Yup.string()
    .required('Password is required.')
    .matches(/\b([A-Z])/g, 'Password requires first letter Capital')
    .max(18, 'Password is too long - should be maximum 20 chars.')
    .min(7, 'Password is too short - should be 8 chars minimum.')
    .matches(/[0-9]/, 'Password requires a number')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[^\w]/, 'Password requires a special chars'),
  otpCode: Yup.string().when('$showOTP', {
    is: true,
    then: (schema) => schema
      .required('OTP is required.')
      .matches(/^\d{6}$/, 'OTP must be exactly 6 digits')
      .length(6, 'OTP must be exactly 6 digits'),
    otherwise: (schema) => schema.notRequired()
  })
});
export const resetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required.')
    .max(18, 'Password is too long - should be maximum 20 chars.')
    .min(7, 'Password is too short - should be 8 chars minimum.')
    .matches(/[0-9]/, 'Password requires a number')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[^\w]/, 'Password requires a special chars'),
  confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Password and confirm password does not match').required('Confirm password is required.'),
});